import { defineMessages } from 'react-intl';

export default defineMessages({
    createAccount: {
        id: 'app.signup.instructions.completeSignup',
        defaultMessage: 'Let\'s create your account'
    },
    fastAndSecure: {
        id: 'app.signup.instructions.fastAndSecure',
        defaultMessage: 'Signup up for Alva is fast and secure.'
    },
    justTheBasics: {
        id: 'app.signup.instructions.justTheBasics',
        defaultMessage: 'Just the basics'
    },
    tellUsAboutYou: {
        id: 'app.signup.instructions.tellUsAboutYou',
        defaultMessage: 'Tell us about you so we can serve you better.'
    },
    safeAndSecure: {
        id: 'app.signup.instructions.safeAndSecure',
        defaultMessage: 'Safe and secure'
    },
    needInfo: {
        id: 'app.signup.instructions.needInfo',
        defaultMessage: 'We need your name and email to better protect your identity and data.'
    }
});
